<script setup lang="ts">
defineProps<{
  to: string;
  icon: string;
  title: string;
  description: string;
  /** A short qualifier rendered as a tag after the title, e.g. "Beta". */
  tag?: string;
  /**
   * Accent colour for the card. `neutral` is the fallback for a library whose
   * kind has no accent of its own — it carries no `.library-*` accent rule, so
   * the base card and icon styles apply. Never borrow another kind's variant
   * for an unrecognised kind: a library wearing the wrong type's colour is the
   * defect PRD R3 forbids, and it is less obvious than a plain grey card.
   *
   * Each named variant needs a matching `.library-browse-card.library-*` rule
   * in styles/components.css, and that rule should agree with the kind's chip
   * colour from tagVariant() — they are two separate systems.
   */
  variant: 'cle' | 'cpe' | 'skills' | 'microlearning' | 'simulation' | 'neutral';
}>();
</script>

<template>
  <RouterLink :to="to" :class="['library-browse-card', `library-${variant}`]">
    <div class="library-browse-icon">
      <bb-icon :name="icon" decorative></bb-icon>
    </div>
    <div class="library-browse-info">
      <h3>
        {{ title }}
        <span v-if="tag" class="bb-tag -size-xs -info library-browse-tag">{{ tag }}</span>
      </h3>
      <p>{{ description }}</p>
    </div>
    <bb-icon name="chevron_right" class="library-browse-arrow" decorative></bb-icon>
  </RouterLink>
</template>
